import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import assign from 'object-assign';

import DetailView from '../Common/DetailView';
// constants
import ROLES from '../../constants/Roles';
import { ModuleDialogs } from '../../constants/Dialogs';
import { DateStyles } from '../../constants/CentricConstants';
// formatters
import { FormattedDate } from 'react-intl';
import AutoComplete from '../Common/AutoComplete';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import AssetSegmentAdmin from '../Asset/AssetSegmentAdmin';
import TrainerSegmentAdmin from './TrainerSegmentAdmin';
import Dialog from 'material-ui/Dialog';
import ErrorSnackbar from '../Common/ErrorSnackbar';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import ModuleAccessGroupSegment from './ModuleAccessGroupSegment';
import ModuleMediaCard, { getModuleCode } from './ModuleMediaCard';
import ModuleReminderCard from './ModuleReminderCard';
import EnrolmentIcon from 'material-ui/svg-icons/action/check-circle';

import IconSettings from 'material-ui/svg-icons/action/settings';
// icons
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import EventIcon from 'material-ui/svg-icons/action/event';
import InfoIcon from 'material-ui/svg-icons/action/info';
import TimeLineIcon from 'material-ui/svg-icons/action/timeline';
import AssetActions from '../../actions/AssetActionCreator';
import AssetStore from '../../stores/AssetStore';

import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleAssetStore from '../../stores/ModuleAssetStore';
import ModuleMediaStore from '../../stores/ModuleMediaStore';
import ModuleStore from '../../stores/ModuleStore';
import ModuleTrainerStore from '../../stores/ModuleTrainerStore';
import UserActions from '../../actions/UserActionCreator';
import TrainerStore from '../../stores/TrainerStore';

import buildContextMenu from '../Common/BuildContextMenu';
import { formatName } from '../../utils/StringUtils';
import { withId } from '../Common/Decorators';
import SetModuleCodeDialog from './SetModuleCodeDialog';
import DialogActions from '../../actions/DialogActionCreator';
import { statusColours } from '../../constants/ColourConstants';
// structure

// business

let timeout;

const getMenuItems = (id, data, auth, onDelete) => {
    const canEdit = !!data && auth.canEdit(data.access);
    return [
        {
            link: `/dashboard/module/${ id}`,
            icon: <InfoIcon />,
            label: 'Preview'
        },
        {
            link: `/dashboard/module/${id}/events`,
            icon: <EventIcon />,
            label: 'Events'
        },
        {
            type:'divider'
        },
        {
            link: `/dashboard/module/${id}/enrolments`,
            icon: <EnrolmentIcon />,
            label: 'Enrolments',
            condition: {
                roles: [ROLES.MANAGER]
            }
        },
        {
            link: `/dashboard/module/${id}/activity`,
            icon: <TimeLineIcon />,
            label: 'Activity',
            condition: {
                roles: [ROLES.ADMIN],
                show: (!!data && !!data.mediaId)
            }
        },
        {
            type: 'divider'
        },
        {
            link: `/dashboard/module/${id}/edit`,
            icon: <EditIcon />,
            label: 'Edit',
            condition: {
                show:  canEdit,
                roles: [ROLES.ADMIN]
            }
        },
        {
            action: () => DialogActions.open(ModuleDialogs.SET_CODE, {id, code: getModuleCode(data)}),
            icon: <EditIcon />,
            label: 'Edit Code',
            condition: {
                show:  canEdit && !data.code,
                roles: [ROLES.ADMIN]
            }
        },
        {
            type: 'deleteDialog',
            dialogType: 'menu',
            value: id,
            title: 'Delete ',
            deleteAction: onDelete,
            message: (<span>Are you sure you want to delete this module?</span>),
            condition: {
                show: canEdit,
                roles: [ROLES.ADMIN]
            }
        }
    ];
};

const ModuleSettings = React.createClass({

    getInitialState: function(){
        return {
            dialog: {
                open: '',
                value: null
            },
            open: false,
            details: {
                name: '',
                description: '',
                theme: '',
                image: '',
                overview: '',
                duration: '',
                cost: '',
                price: '',
                url: '',
                type: '',
                mediaId: null,
                mediaName: '',
                category: '',
                status: '',
                code: '',
                capacity: '',
                version: '',
                visibility: '',
                repeatable: false,
                launchAsPopup: null,
                accessGroup: '',
                skillId: null,
                skillName: '',
                skillCode: '',
                skillLevel: '',
                emailTemplate: '',
                emailTemplateId: '',
                validFrom: '',
                validTo: null,
                vendor: '',
                vendorId: '',
                cpdCredits: ''
            },
            assets: [],
            assetList: [],
            trainers: [],
            trainerList: [],
            media: {
                id: '',
                title: '',
                versions: 0,
                versionData: []
            },
            actions: [],

            links: {
                back: '/dashboard/module/' + this.props.routeParams.id,
                edit: ''
            }
        };
    },

    componentWillMount() {
        this._onModuleChange();
        this._onTrainerChange();
        this._onModuleAssetChange();
        this._onMediaChange();
        this._onTrainerListChange();
        this._onAssetChange();
    },

    componentDidMount: function(){
        this.setState( assign({}, this.state, { actions: buildContextMenu(getMenuItems(this.props.id), this.context.auth) }) );

        this.listeners = [
            ModuleStore.addListener(this._onModuleChange),
            ModuleTrainerStore.addListener(this._onTrainerChange),
            ModuleAssetStore.addListener(this._onModuleAssetChange),
            ModuleMediaStore.addListener(this._onMediaChange),
            TrainerStore.addListener(this._onTrainerListChange),
            AssetStore.addListener(this._onAssetChange),
        ];
        ModuleActions.getById(this.props.id);
        ModuleActions.getTrainers(this.props.id);
        ModuleActions.getAssets(this.props.id);
        UserActions.getTrainers();
        AssetActions.getAll();

    },

    componentWillUnmount: function() {
        this.listeners.forEach( listener => listener.remove() );
    },

    getDialog: function() {
        if (!this.state.dialog.open) { return null; } // guard

        let dialogProps = {open: true};

        const dialogActions = [
            <FlatButton key="cancel" label="Cancel" onTouchTap={this._closeDialog} />,
            <FlatButton key="submit" label="Submit" onTouchTap={this._dialogSave} disabled={this.state.dialog.value === null} />
        ];

        switch (this.state.dialog.open) {

            case ModuleDialogs.TRAINER_ADD:
                dialogProps = {
                    open: true,
                    title: "Add trainer",
                    modal: false,
                    actions: dialogActions,
                    onRequestClose: this._closeDialog
                };
                return (
                    <Dialog {...dialogProps} >
                        <AutoComplete
                            floatingLabelText="Trainer"
                            maxSearchResults={5}
                            dataSource={this.state.trainerList}
                        />
                    </Dialog>
                );

            case ModuleDialogs.ASSET_ADD:
                dialogProps = {
                    open: true,
                    title: "Add attachment",
                    modal: false,
                    actions: dialogActions,
                    onRequestClose: this._closeDialog
                };
                return (
                    <Dialog {...dialogProps} >
                        <AutoComplete
                            floatingLabelText="Asset"
                            maxSearchResults={5}
                            dataSource={this.state.assetList}
                            onUpdateInput={this._onAssetAutocomplete}
                        />
                    </Dialog>
                );

            default:
                return null;
        }
    },

    render: function(){

        return (

            <DetailView
                title={this.state.details.name}
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card cent-card-12">
                        <CardHeader
                            title="Settings"
                            subtitle="general module settings"
                            avatar={<IconSettings color={statusColours.default}/>}
                        />
                        <CardText className="cent-card-text">
                            <div className='cent-flex-row'>
                                <div className='cent-col-2'>
                                    <ul className="cent-list-plain">
                                        <li><em>Code: </em>{this.state.details.code}</li>
                                        <li><em>Version: </em>{this.state.details.version}</li>
                                        <li><em>Type: </em>{this.state.details.type}</li>
                                        <li>
                                            <em>Category: </em>
                                            <Link to={`/dashboard/library/${this.state.details.categoryId || 'uncategorised'}`}>{this.state.details.category || 'Uncategorised'}</Link>
                                        </li>
                                        <li><em>Visibility: </em>{this.state.details.visibility} {!!this.state.details.isRepeatable && this.state.details.type === 'e-learning' && this.state.details.visibility === 'private' &&  '(relaunchable)'}</li>
                                        <li><em>Scope: </em>{this.state.details.accessGroup}</li>
                                        <li>
                                            <em>Available from: </em>
                                            {!!this.state.details.validFrom && <FormattedDate value={this.state.details.validFrom} {...DateStyles.long} />}
                                        </li>
                                        <li>
                                            <em>Available to: </em>
                                            {!!this.state.details.validTo && <FormattedDate value={this.state.details.validTo} {...DateStyles.long} />}
                                        </li>
                                        <li><em>Status: </em>{this.state.details.status}</li>
                                    </ul>
                                </div>
                                <div className='cent-col-2'>
                                    <ul className="cent-list-plain">
                                        <li><em>Duration: </em>{this.state.details.duration}</li>
                                        <li><em>Capacity: </em>{this.state.details.capacity}</li>
                                        <li>
                                            <em>Skill: </em>
                                            <Link to={`/dashboard/skill/${this.state.details.skillId || ''}`}>{this.state.details.skillName || ''}</Link>
                                        </li>
                                        <li><em>URL: </em>{this.state.details.url}</li>
                                        <li><em>Email template: </em>{this.state.details.emailTemplate}</li>
                                        <li>
                                            <em>Vendor: </em>
                                            <Link to={`/dashboard/vendor/${this.state.details.vendorId}`}>{this.state.details.vendor || ''}</Link>
                                        </li>
                                        <li><em>Cost: </em>{this.state.details.cost}</li>
                                        <li><em>Price: </em>{this.state.details.price}</li>
                                        <li>
                                            <em>Media:</em>
                                            <Link to={`/dashboard/asset/${this.state.details.mediaId}`}>{this.state.details.mediaName || ''}</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </CardText>
                    </Card>

                    {(!!this.state.details.mediaId && 'e-learning' === this.state.details.type) && (
                        <ModuleMediaCard
                            data={this.state.media}
                            moduleCode={this.state.details.mediaCode}
                            mediaId={this.state.details.mediaId}
                            moduleId={this.props.id}
                            launchAsPopup={this.state.details.launchAsPopup}
                        />
                    )}

                    <ModuleReminderCard moduleId={this.props.id} />

                    <TrainerSegmentAdmin
                        trainers={this.state.trainers}
                        addAction={this._openDialog.bind(this, ModuleDialogs.TRAINER_ADD)}
                        deleteAction={(trainerId) => ModuleActions.removeTrainer(this.props.id, trainerId)}
                    />

                    <ModuleAccessGroupSegment moduleId={this.props.id}/>

                    <AssetSegmentAdmin
                        assets={this.state.assets}
                        addAction={this._openDialog.bind(this, ModuleDialogs.ASSET_ADD)}
                        deleteAction={(assetId) => ModuleActions.removeAsset(this.props.id, assetId)}
                    />

                </div>

                {this.getDialog()}
                <SetModuleCodeDialog />
                <ErrorSnackbar />
            </DetailView>

        );
    },

    _onModuleChange: function(){
        const details = ModuleStore.getById(this.props.id);
        if (details !== undefined) {
            let state = {...this.state, details: details };
            if (details.type === 'e-learning' && !!details.mediaCode && !!details.mediaId && !this.state.media.id ) {
                ModuleActions.getMediaInfo(details.mediaCode);
                state.media.id = 'loading';
            }
            this.setState({...state, actions: buildContextMenu(getMenuItems(this.props.id, details, this.context.auth, this._onDelete), this.context.auth)});
        }
    },

    _onTrainerChange: function() {
        const trainers = ModuleTrainerStore.getByModule(this.props.id);
        if (trainers !== undefined) {
            const trainerData = trainers.map(function(trainer) {
                const fullName = (trainer.fullName || formatName(trainer));
                return {
                    id: trainer.userId,
                    name: fullName,
                    loading: !!trainer.loading
                };
            });
            this.setState({trainers: trainerData});
        }
    },

    _onTrainerListChange: function() {
        const trainers = TrainerStore.getAll();
        if (trainers !== undefined) {
            const trainerList = trainers.map(function(trainer) {
                const click = this._onDialogSelect.bind(this, trainer);
                const fullName = (trainer.fullName || formatName(trainer));
                return {
                    key: `TRN${trainer.id}`,
                    text: fullName,
                    value: <MenuItem onTouchTap={click} key={trainer.id} value={trainer.id} primaryText={fullName} />
                };
            }, this);
            this.setState({trainerList: trainerList});
        }
    },

    // dialog handlers:
    _onMediaChange: function() {
        const media = ModuleMediaStore.getById(this.state.details.mediaCode);
        if (!!media) {
            this.setState({media});
        } else {
            this.setState({media: {...this.state.media, id: null}});
        }
    },

    _addTrainer: function(trainer) {
        let ok = true;
        let trainerId = Number(trainer.id);
        if (!!this.state.trainers.find((e) => ( e !== undefined && e.id === trainerId ))) {
            ok = false;
            let dialog = this.state.dialog;
            dialog.value = null;
            this.setState({dialog: dialog});
        } else {
            ModuleActions.addTrainer(this.props.id, trainer.id);
            const fullName = (trainer.fullName || formatName(trainer));
            const trainers = [
                ...this.state.trainers,
                {id: trainer.id, name: fullName, loading: true}
            ];
            this.setState({trainers: trainers});
        }
        return ok;
    },

    _onModuleAssetChange: function() {
        const assets  = ModuleAssetStore.getByModule(this.props.id);
        if (assets !== undefined) {
            this.setState({assets: assets});
        }
    },

    addAsset: function(asset) {
        if (asset !== undefined) {
            const index = this.state.assets.findIndex(function(e) { return e !== undefined && e.id == asset.id; });
            if (0 > index) {
                asset.loading = true;
                delete asset.dateAdded;
                let assets = this.state.assets;
                assets.push(asset);
                this.setState({assets: assets});
                ModuleActions.addAsset(this.props.id, asset.id);
            }
            return true;
        }
    },

    _onAssetAutocomplete: function(input) {
        clearTimeout(timeout);
        if (input !== undefined && input.length >= 2) {
            timeout = setTimeout(function() {
                AssetActions.search(input, {limit: 10});
                this.setState({searchString: input});
            }.bind(this), 500);
        }
    },

    _onAssetChange: function() {
        if (!this.state.searchString) { return; }
        const assets = AssetStore.search(this.state.searchString);
        if (assets !== undefined) {
            const assetList = assets
                .filter(({type}) => type !== 'e-learning')
                .map((asset) => {
                    const click = this._onDialogSelect.bind(this, asset);
                    const name = `${asset.name} (${asset.type})`;
                    return {
                        text: asset.name,
                        value: <MenuItem key={asset.id} value={asset.id} primaryText={name} onTouchTap={click} />
                    };
                }, this);
            this.setState({assetList: assetList});
        }
    },

    _openDialog: function(dialog) {
        let state = this.state;
        state.dialog.open = dialog;
        state.dialog.value = null;
        this.setState(this.state);
    },

    _closeDialog: function() {
        let state = this.state;
        state.dialog.open = '';
        this.setState(this.state);
    },

    _onDialogSelect: function(element) {
        let dialog = this.state.dialog;
        dialog.value = element;
        this.setState({dialog: dialog});
    },

    _dialogSave: function() {
        let close = true;
        switch (this.state.dialog.open) {
            case ModuleDialogs.TRAINER_ADD:
                close = this._addTrainer(this.state.dialog.value);
                break;
            case ModuleDialogs.ASSET_ADD:
                close = this.addAsset(this.state.dialog.value);
                break;
            default:
                console.error('unhandled dialog');
                close = false;
        }

        if (close) this._closeDialog();
    },

    _onDelete: function(entityId) {
        if (entityId === this.props.id) {
            ModuleActions.delete(entityId);
            window.location.href = '/dashboard/modules';
        }
    }

});

ModuleSettings.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(ModuleSettings);
